export default __webpack_public_path__ + "static/media/HOME_phones.e7a126dc.png";